import { Close } from '@mui/icons-material';
import CloudSyncIcon from '@mui/icons-material/CloudSyncTwoTone';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useDenyUnsupportedFileContactConsentMutation } from '../../../api/gql';
import { notify } from '../../../utils/notification';
import { useSafeNavigation } from '../../../hooks/useSafeNavigation';

const TRANS_NS = 'unsupported-file';

export const UnsupportedFile = () => {
  const { t } = useTranslation(TRANS_NS);
  const { safeNavigate } = useSafeNavigation();
  const { fileId } = useParams();

  const { mutate, isPending } = useDenyUnsupportedFileContactConsentMutation({
    onSuccess() {
      notify.warning({ message: t('mutation.success') });
      safeNavigate('/upload', { replace: true });
    },
    onError() {
      notify.negative({ message: t('mutation.error') });
    },
  });

  const handleClick = () => {
    mutate({ id: fileId as string });
  };

  const handleClose = () => safeNavigate('..', { replace: true });

  return (
    <Dialog open={true} onClose={handleClose} aria-labelledby="modal-title" aria-describedby="modal-description">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          px: 2,
          py: 4,
          textAlign: 'center',
          gap: 4,
        }}
      >
        <CloudSyncIcon sx={{ fontSize: 69 }} color={'primary'} />
        <Box px={4}>
          <Typography>{t('description')}</Typography>
        </Box>
        <Stack gap={2}>
          <Button size={'large'} variant={'contained'} onClick={handleClose}>
            {t('contactMe')}
          </Button>
          <LoadingButton
            loading={isPending}
            variant={'outlined'}
            color={'warning'}
            size={'small'}
            onClick={handleClick}
          >
            {t('action')}
          </LoadingButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
